export const loaderTypes = {
  GENERAL: 'general',
  PROPERTY: 'property',
  TU: 'tu',
};
